import React from 'react';
import { Link } from 'react-router-dom';


const ReturnPolicy = () => {
  return (
    <div className="return-policy">
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(assets/img/bg-img.png)' }}></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Return Policy</h1>
            <ul className="bread-crumb clearfix">
              <li> <Link  href="/">Home </Link></li>
              <li>Return Policy</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="service-details industries-details">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 content-side">
              <div className="service-details-content">
                <div className="content-three">
                  <div className="upper-box">
                    <h3>Return Policy</h3>
                    <p>
                      At SNKB Berings, we prioritize customer satisfaction and strive to ensure a seamless shopping experience. If you receive an item that is damaged, doesn't match the listing description, or is incorrect, you have the option to return it for a refund. However, we kindly request that the item be returned in its original packaging.
                    </p>
                    <br />
                    <p>
                      Please note that if the original packaging is damaged by any source, a deduction of 30% of the shipment value will be applied to cover the incurred costs.
                    </p>
                    <br />
                    <p>
                      Our return policy is valid for a period of 7 days from the receipt of the material. We understand the importance of prompt action, so we urge customers to initiate the return process within this timeframe to facilitate a smooth resolution.
                    </p>
                    <br />
                    <p>
                      Upon receiving the returned material and conducting a thorough inspection to ensure its condition, we will promptly issue a refund in accordance with our policy. Your satisfaction is paramount to us, and we are committed to addressing any concerns you may have with the utmost care and attention.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReturnPolicy;
